import {
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableBody,
  Paper,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import BellIcon from "../../../assets/icons/BellIcon";
import BookmarkIcon from "../../../assets/icons/BookmarkIcon";
import DeleteIcon from "../../../assets/icons/DeleteIcon";
import SearchIcon from "../../../assets/icons/SearchIcon";
import Checkbox from "../../../common/Checkbox";
import { SecondaryButton } from "../../../common/Buttons";

import LayoutWrapper from "../../../common/LayoutWrapper";

import "./index.scss";
import { getSectionStatuses } from "../../../services/documentServices";
import { useDispatch, useSelector } from "react-redux";
import { getStatusQuoAutditTrail } from "../../../services/auditTrails";
import { getUpdatedData } from "../../../redux/slices/DocumentsSlice";
import { resetCard } from "../../../redux/slices/CardSlices";
import { resetTab } from "../../../redux/slices/TabSlices";
import { documentStatusesNotToNavigate } from "../../../constants/constants";
import {
  setDocumentsLoadingStateDisable,
  setDocumentsLoadingStateEnable,
} from "../../../redux/slices/CasesSlice";
import { Circles } from "react-loader-spinner";
import { useTranslation } from "react-i18next";
import { getKeyFromText } from "../../../utils/Utilities";
const dummyData = [
  {
    id: 1,
    name: "Testament",
    status: "Uploaded",
    route: "testament",
  },
  {
    id: 2,
    name: "Healthcare proxy",
    status: "Uploaded",
    route: "healthcare-proxy",
  },
  {
    id: 3,
    name: "Guardianship ordinance",
    status: "In progress",
    route: "guardianship-ordinance",
  },
  {
    id: 4,
    name: "Care directive",
    status: "Requested",
    route: "care-directive",
  },
  {
    id: 5,
    name: "Custody order",
    status: "In progress",
    route: "custody-order",
  },
  {
    id: 6,
    name: "Organ donation",
    status: "Finished",
    route: "organ-donation",
  },
];

const DocProgress = () => {
  const { t } = useTranslation();
  let navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();
  let dispatch = useDispatch();
  const updates = useSelector((state) => state.statusQuoDocuments.updates);
  const loading = useSelector(
    (state) => state.casesState.cases.documentsLoading
  );
  let statusColors = {
    uploaded: "#8DADDE",
    finished: "#FF996C",
    requested: "#77C790",
  };
  const [list, setList] = useState([]);
  const handleChangeCheck = (e) => {
    setList(
      list.map((item) => {
        if (item.id == e.target.id)
          return { ...item, isChecked: !item.isChecked };
        return item;
      })
    );
  };
  const handleNameClick = (url) => {
    navigate(`${url}`);
  };
  const fetchData = async () => {
    dispatch(setDocumentsLoadingStateEnable());
    try {
      const result = await getSectionStatuses(id);
      if (result?.success) {
        setList(
          result?.payLoad
            ?.filter((item) => item?.title?.length > 0)
            .map((item, index) => {
              return {
                id: item?.sortingId,
                name: item?.title,
                status: item?.status,
                route:
                  item?.title?.toLowerCase() === "organ donation document"
                    ? "organ-donation"
                    : item?.title?.toLowerCase().replaceAll(" ", "-"),
                highlight: Object.values(updates)[index]?.length > 0 || false,
              };
            })
        );
      }
    } catch (e) {
      console.log(e);
    } finally {
      dispatch(setDocumentsLoadingStateDisable());
    }
  };

  useEffect(() => {
    dispatch(resetCard());
    dispatch(resetTab());
  }, [location.pathname]);

  useEffect(() => {
    fetchData();
  }, [
    updates.healthcare,
    updates.careDirective,
    updates.guardianOrdinance,
    updates.organDonation,
  ]);

  return (
    <>
      <div
        className="summary-table"
        style={{
          minHeight: "500px",
          overflow: "auto",
          display: "flex",
          justifyContent: "center",
          alignItems: loading && "center",
        }}
      >
        {loading ? (
          <Circles color="#dfc8db" height={80} width={80} />
        ) : (
          <TableContainer component={Paper}>
            <Table
              sx={{ minWidth: 650, maxHeight: "300px", overflow: "auto" }}
              aria-label="simple table"
            >
              <TableHead>
                <TableRow>
                  <TableCell sx={{ width: "30px" }}>
                    <DeleteIcon style={{ width: "25px", margin: "10px" }} />
                  </TableCell>
                  <TableCell align="left">
                    {t(getKeyFromText("Type"))}
                  </TableCell>
                  <TableCell align="center">
                    {t(getKeyFromText("Updated Content"))}
                  </TableCell>
                  <TableCell></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {list.map((item, index) => {
                  return (
                    <TableRow
                      key={item.id}
                      sx={{ backgroundColor: item.highlight && "#dfc8db" }}
                    >
                      <TableCell
                        component="th"
                        scope="row"
                        align="center"
                        onClick={() =>
                          !documentStatusesNotToNavigate.includes(
                            item.status.toLowerCase()
                          ) && handleNameClick(item.route)
                        }
                        sx={{
                          cursor:
                            !documentStatusesNotToNavigate.includes(
                              item.status.toLowerCase()
                            ) && "pointer",
                        }}
                      >
                        <div
                          style={{
                            margin: "5px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <Checkbox
                            id={item.id}
                            checked={item.isChecked}
                            onChange={handleChangeCheck}
                          />
                        </div>
                      </TableCell>

                      <TableCell
                        onClick={() =>
                          !documentStatusesNotToNavigate.includes(
                            item.status.toLowerCase()
                          ) && handleNameClick(item.route)
                        }
                        sx={{
                          cursor:
                            !documentStatusesNotToNavigate.includes(
                              item.status.toLowerCase()
                            ) && "pointer",
                        }}
                      >
                        {t(getKeyFromText(item.name))}
                      </TableCell>

                      <TableCell
                        align="right"
                        onClick={() =>
                          !documentStatusesNotToNavigate.includes(
                            item.status.toLowerCase()
                          ) && handleNameClick(item.route)
                        }
                        sx={{
                          cursor:
                            !documentStatusesNotToNavigate.includes(
                              item.status.toLowerCase()
                            ) && "pointer",
                        }}
                      ></TableCell>
                      <TableCell
                        align="right"
                        onClick={() =>
                          !documentStatusesNotToNavigate.includes(
                            item.status.toLowerCase()
                          ) && handleNameClick(item.route)
                        }
                        sx={{
                          cursor:
                            !documentStatusesNotToNavigate.includes(
                              item.status.toLowerCase()
                            ) && "pointer",
                        }}
                      >
                        <SecondaryButton
                          title={t(getKeyFromText(item?.status || ""))}
                          width="170px"
                          fontWeight="400"
                          padding="0.5rem"
                          fontSize="0.77rem"
                          bgColor={`${
                            statusColors[item.status.toLowerCase()] ||
                            "#FFD76C !important"
                          }`}
                          border="none"
                          pointerEvents="none"
                        />
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </div>
    </>
  );
};

export default DocProgress;
